import { range, checkForNestedProperty } from 'utils/utils';

const privateUtils = {
  addIdToArrayItems(arrayObject) {
    arrayObject.map((item, index) => {
      item.id = index;
    });

    return arrayObject;
  },

  addPassengerIds(info) {
    if (checkForNestedProperty(info, 'passenger_details.0.0') && !checkForNestedProperty(info, 'passenger_details.0.0.id')) {
      let index = 0;

      info.passenger_details.forEach((room) => {
        room.forEach((passenger) => {
          passenger.id = index;
          index += 1;
        });
      });
    }
  },

  createPassenger(id, paxType) {
    return {
      id,
      paxType,
    };
  },

  getReservedIds(passengers) {
    const reservedIds = [];

    passengers.map((passenger) => {
      reservedIds.push(passenger.id);
    });

    return reservedIds;
  },

  getPassengerTypeTotals(passengers) {
    const passengerTypeTotals = {
      adult: 0,
      child: 0,
      infant: 0,
    };

    passengers.map((passenger) => {
      passengerTypeTotals[passenger.paxType] += 1;
    });

    return passengerTypeTotals;
  },

  addPartyInfo(resultJson) {
    const data = resultJson.data || {};

    if (data.party) {
      this.addIdToArrayItems(data.party);

      data.partyInfo = {
        numberOfPassengers: 0,
        numberOfChargeablePassengers: 0,
        numberOfAdults: 0,
        numberOfChildren: 0,
        numberOfInfants: 0,
      };

      data.party.map((partyRoomInfo) => {
        data.partyInfo.numberOfPassengers += partyRoomInfo.num_adults + partyRoomInfo.num_children + partyRoomInfo.num_infants;
        data.partyInfo.numberOfChargeablePassengers += partyRoomInfo.num_adults + partyRoomInfo.num_children;
        data.partyInfo.numberOfAdults += partyRoomInfo.num_adults;
        data.partyInfo.numberOfChildren += partyRoomInfo.num_children;
        data.partyInfo.numberOfInfants += partyRoomInfo.num_infants;
      });
    }
  },

  addFlightMealInfo(resultJson) {
    if (checkForNestedProperty(resultJson, 'data.extras.flightMeals.options') && resultJson.data.extras.flightMeals.options) {
      this.addIdToArrayItems(resultJson.data.extras.flightMeals.options);
    }
  },

  addPassengers(resultJson) {
    const info = resultJson.booking_info || {};

    info.passengers = [];

    if (info.passenger_details) {
      info.passenger_details.map(roomPassengers => info.passengers = info.passengers.concat(roomPassengers));
    }
  },

  addPassengersByRoom(resultJson) {
    const info = resultJson.booking_info || {};

    info.passengersByRoom = {};

    if (info.passenger_details) {
      info.passenger_details.map((roomPassengers, index) => {
        const adults = roomPassengers.filter(passengerItem => passengerItem.paxType === 'adult');
        const children = roomPassengers.filter(passengerItem => passengerItem.paxType === 'child');
        const infants = roomPassengers.filter(passengerItem => passengerItem.paxType === 'infant');

        info.passengersByRoom[index] = {};
        info.passengersByRoom[index].all = roomPassengers;
        info.passengersByRoom[index].adults = adults;
        info.passengersByRoom[index].children = children;
        info.passengersByRoom[index].infants = infants;
      });
    }
  },

  addLeadPassengerIdFromPassengers(resultJson) {
    const info = resultJson.booking_info || {};

    info.leadPassengerId = 0;

    if (info.passengers) {
      info.passengers.map((passengerItem) => {
        if (passengerItem.is_lead) {
          info.leadPassengerId = passengerItem.id;
        }
      });
    }
  },

  populatePlaceholderPassengers(resultJson) {
    const info = resultJson.booking_info || {};
    const data = resultJson.data || {};

    if (data.party) {
      data.party.map((partyRoomInfo, index) => {
        info.passengersByRoom[index] = info.passengersByRoom[index] || {};
        const room = info.passengersByRoom[index];

        const rangeIds = range(data.partyInfo.numberOfPassengers);
        const reservedIds = this.getReservedIds(info.passengers);
        const availableIds = rangeIds.filter(id => !reservedIds.includes(id));

        const currentPassengerTypeTotals = this.getPassengerTypeTotals(room.all || []);

        const numRequiredAdults = partyRoomInfo.num_adults - currentPassengerTypeTotals.adult;
        const adults = Array(numRequiredAdults).fill('adult').map(paxType => this.createPassenger(availableIds.shift(), paxType));

        const numRequiredChildren = partyRoomInfo.num_children - currentPassengerTypeTotals.child;
        const children = Array(numRequiredChildren).fill('child').map(paxType => this.createPassenger(availableIds.shift(), paxType));

        const numRequiredInfants = partyRoomInfo.num_infants - currentPassengerTypeTotals.infant;
        const infants = Array(numRequiredInfants).fill('infant').map(paxType => this.createPassenger(availableIds.shift(), paxType));

        room.adults = room.adults ? room.adults.concat(adults) : adults;
        room.children = room.children ? room.children.concat(children) : children;
        room.infants = room.infants ? room.infants.concat(infants) : infants;

        room.all = room.all ? room.all.concat(adults, children, infants) : adults.concat(children, infants);

        info.passengers = info.passengers.concat(adults, children, infants);
      });
    }
  },

  addIdToRoomPricingOptions(resultJson) {
    const data = resultJson.data || {};

    if (data.room_pricing_options) {
      data.room_pricing_options.map((room) => {
        if (room.restrictions && room.restrictions[0] && typeof room.restrictions[0].id === 'number') {
          room.id = room.restrictions[0].id;
        }
      });
    }
  },

  addRoomRestrictionsAndFlattenRoomPricingOptionsRestrictions(resultJson) {
    const data = resultJson.data || {};

    data.roomRestrictions = [];

    if (data.room_pricing_options) {
      data.room_pricing_options.map((room) => {
        if (room.restrictions) {
          room.restrictions.map((restriction, index) => {
            restriction.roomId = room.id;
            data.roomRestrictions.push(restriction);
            room.restrictions[index] = restriction.id;
          });
        }
      });
    }
  },
};

export { privateUtils };

const api = {
  updateBookJson(resultJson = {}) {
    const info = resultJson.booking_info || {};

    /* istanbul ignore if  */
    if (!info.passenger_details && info.passenger_autofill) {
      info.passenger_details = info.passenger_autofill;
    }

    delete info.passenger_autofill;

    privateUtils.addPassengerIds(info);
    privateUtils.addPartyInfo(resultJson);
    privateUtils.addFlightMealInfo(resultJson);
    privateUtils.addPassengers(resultJson);
    privateUtils.addPassengersByRoom(resultJson);
    delete info.passenger_details;
    privateUtils.addLeadPassengerIdFromPassengers(resultJson);
    privateUtils.populatePlaceholderPassengers(resultJson);

    privateUtils.addIdToRoomPricingOptions(resultJson);
    privateUtils.addRoomRestrictionsAndFlattenRoomPricingOptionsRestrictions(resultJson);
  },
};

export default api;



/** WEBPACK FOOTER **
 ** ./src/redux/middleware/bookJsonUtils.js
 **/